import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

export interface RadioOption {
  label: string;
  value: any;
  type?: 'hidden' | 'disabled';
}

@Component({
  selector: 'app-radio-input',
  templateUrl: './radio-input.component.html',
  styleUrls: ['./radio-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioInputComponent),
      multi: true,
    },
  ],
})
export class RadioInputComponent implements ControlValueAccessor {
  radioFormControl = new FormControl('');

  @Input() options!: RadioOption[];
  @Input() key: string = 'value';
  @Input() placeholder: string = '';
  @Input() label: string = '';
  @Input() bgClass: string = 'bg-white';
  @Input() hasError: boolean = false;
  @Input() readOnly: boolean = false;
  @Input() required: boolean = false;

  propagateChange = (_: any) => {};
  touchChange = (_: any) => {};

  onSelectionChange() {
    this.propagateChange(this.radioFormControl.value);
  }

  writeValue(obj: any): void {
    if (obj !== undefined && obj !== null) {
      this.radioFormControl.setValue(obj);
    } else {
      this.radioFormControl.setValue('');
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.touchChange = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.radioFormControl.disable();
    } else {
      this.radioFormControl.enable();
    }
  }


}
